import type { ReactNode } from 'react';

import { escapeRegExp } from 'lodash-es';

export const renderHighlightedText = (
  text: string,
  search?: string,
): ReactNode => {
  if (!search) {
    return text;
  }

  const parts = text.split(new RegExp(`(${escapeRegExp(search)})`, 'gi'));
  if (parts.length === 1) {
    return text;
  }

  return parts.map((part, index) =>
    index % 2 ? <mark key={index}>{part}</mark> : part,
  );
};
